import { apiRequest } from "@/api";

const state = {
  products: {},
  categories: [""],
  brands: [""],
  colors: [""],
  gender: [""],
  materials: [""],
  sizes: [""],
  OnSaleVals: ["", "On sale", "Off sale"],
  customs: [],
};

const getters = {
  filterProducts: (state) => (
    category,
    brand,
    color,
    gender,
    material,
    size,
    on_sale
  ) => {
    console.info("filter : ", {
      category,
      brand,
      color,
      gender,
      material,
      size,
      on_sale,
    });
    return Object.values(state.products).filter((p) => {
      var a = true;
      const ONSALE = on_sale === "On sale" ? true : false;
      a = category ? p.categories.includes(category) : a;
      a = brand ? p.brand === brand && a : a;
      a = color ? p.colors.includes(color) && a : a;
      a = material ? p.material.includes(material) && a : a;
      a = size ? p.sizes_arr.includes(size) && a : a;
      a = gender ? p.gender === gender && a : a;
      a = on_sale ? p.on_sale === ONSALE && a : a;
      return a;
    });
  },
};

const mutations = {
  SET_PRODUCTS: (state, object) => {
    state.products = {};
    for (var i = 0; object[i]; i++) {
      object[i].sizes_arr = [];
      if (object[i].colors) {
        object[i].colors.map((p) => {
          if (!state.colors.includes(p)) state.colors.push(p);
        });
      }
      if (object[i].material) {
        object[i].material.map((p) => {
          if (!state.materials.includes(p)) state.materials.push(p);
        });
      }
      if (object[i].categories) {
        object[i].categories.map((p) => {
          if (!state.categories.includes(p)) state.categories.push(p);
        });
      }
      if (!state.brands.includes(object[i].brand))
        state.brands.push(object[i].brand);

      if (object[i].gender && !state.gender.includes(object[i].gender))
        state.gender.push(object[i].gender);

      if (object[i].sizes) {
        if (
          object[i].sizes[0] == "{" &&
          object[i].sizes[object[i].sizes.length - 1] == "}"
        ) {
          const temp = object[i].sizes.slice(1, -1).replaceAll('"', "");
          const szs = temp.split(",");
          object[i].sizes_arr = szs;
          for (let i = 0; i < szs.length; i++) {
            const element = szs[i];
            if (!state.sizes.includes(element)) {
              state.sizes.push(element);
            }
          }
        } else {
          let szs2 = [];
          if (object[i].sizes.includes(",")) {
            szs2 = object[i].sizes.split(",");
          } else {
            szs2 = [object[i].sizes];
          }
          for (let j = 0; j < szs2.length; j++) {
            const element = szs2[j];
            if (!state.sizes.includes(element)) {
              state.sizes.push(element);
            }
          }
          object[i].sizes_arr = szs2;
        }
      }
      object[i].selected = false;
      state.products[object[i].product_id] = object[i];
      const keys = Object.keys(object[i].custom);
      if (keys.length) {
        keys.forEach((ele) => {
          if (!state.customs.includes(ele)) {
            state.customs.push(ele);
          }
        });
      }
    }
  },
};

function get_other_prods(products, prod_set) {
  let res = [];
  for (const [key, value] of Object.entries(products)) {
    if (!prod_set.includes(key)) res.push(key);
  }
  return res;
}

function get_disliked_prods(products, prod_disliked) {
  let comments = [];
  let result = [];
  for (const [key, value] of Object.entries(prod_disliked)) {
    if (products[key]) {
      const obj = {};
      result.push(key);
      /// avoid duplicated comments
      let comm = [];
      value.forEach((c) => {
        if (!comm.includes(c)) {
          comm.push(c);
        }
      });
      comments.push(comm);
    }
  }
  return { result, comments };
}

const actions = {
  SET_DISLIKED_PRODUCT: async ({ rootState, state }) => {
    const { result, comments } = await get_disliked_prods(
      state.products,
      rootState.user.infos.user.products_disliked
    );
    rootState.user.infos.user.products_disliked_set = result;
    rootState.user.infos.user.products_disliked_comments = comments;
  },
  SET_OTHER_PRODS: async ({ rootState, state }) => {
    const result = await get_other_prods(
      state.products,
      rootState.user.infos.prod_set
    );
    rootState.user.infos.user.outher_prods = result;
  },
  FETCH_PRODUCTS: ({ commit }) => {
    commit("SET_PRODUCTS", []);
    return apiRequest()
      .get("products/all")
      .then((response) => {
        commit("SET_PRODUCTS", response.data.response);
      });
  },
  // eslint-disable-next-line no-empty-pattern
  UPDATE_PRODUCTS: ({}, params) =>
    new Promise((resolve, reject) => {
      apiRequest()
        .post("products/update", params)
        .then(({ data }) => {
          resolve(data);
        })
        .catch((e) => {
          reject(e);
        });
    }),
  UPDATE_PRD: ({}, params) =>
    new Promise((resolve, reject) => {
      apiRequest()
        .post("products/update_prod", params)
        .then(({ data }) => {
          resolve(data);
        })
        .catch((e) => {
          reject(e);
        });
    }),
  FETCH_PRODUCT_ADDED_TO_CART: async ({ rootState }) => {
    return new Promise((resolve, reject) => {
      apiRequest()
        .get("matomo/productAddedToCart/")
        .then((response) => {
          console.log("add to card--->", response);
          if (response.data.result)
            rootState.productAdded = Object.assign(response.data.result);
          resolve(response);
        })
        .catch((e) => {
          reject(e);
        });
    });
  },
  FETCH_PRODUCT_PURCHASE: async ({ rootState }) => {
    return new Promise((resolve, reject) => {
      apiRequest()
        .get("matomo/productPurchase/")
        .then((response) => {
          console.log("PURCHASE --->", response);
          if (response.data.result)
            rootState.productPurchase = Object.assign(response.data.result);
          resolve(response);
        })
        .catch((e) => {
          reject(e);
        });
    });
  },
};

export default { state, mutations, actions, getters };
